<h4 class="f-w-700 f-s-24 m-t-24 m-b-8 text-capitalize">{{"login.log_in" | translate}}</h4>
<span class="f-s-14 d-block mat-body-1 m-t-8">{{"login.xrsupport_dashboard"|translate}}</span>

<div class="or-border m-t-30 text-capitalize">{{"login.log_in" | translate}}</div>

<form class="m-t-30" [formGroup]="loginForm" (ngSubmit)="onSubmit()" #loginFormDir="ngForm">
  <mat-label class="f-s-14 f-w-600 m-b-12 d-block">{{"login.email" | translate}}</mat-label>
  <mat-form-field appearance="outline" class="w-100" color="primary">
    <input matInput formControlName="email" id="email"/>
    <mat-error *ngIf="emailFormControl?.hasError('required') && (emailFormControl?.touched || loginFormDir.submitted)">
      {{ 'login.email_required' | translate }}
    </mat-error>
    <mat-error *ngIf="emailFormControl?.hasError('email') && (emailFormControl?.touched || loginFormDir.submitted)">
      {{ 'login.invalid_email' | translate }}
    </mat-error>
  </mat-form-field>

  <mat-label class="f-s-14 f-w-600 m-b-12 d-block">{{"login.password" | translate}}</mat-label>
  <mat-form-field appearance="outline" class="w-100" color="primary">
    <input matInput [type]="hidePassword ? 'password' : 'text'" id="password" formControlName="password" />
    <button mat-icon-button matSuffix type="button" class="password-toggle" (click)="hidePassword = !hidePassword"
            [attr.aria-label]="(hidePassword ? 'login.show_password' : 'login.hide_password') | translate"
            [attr.aria-pressed]="!hidePassword">
      <i-tabler [name]="hidePassword ? 'eye' : 'eye-off'" class="icon-18"></i-tabler>
    </button>
    <mat-error *ngIf="passwordFormControl?.hasError('required') && (passwordFormControl?.touched || loginFormDir.submitted)">
      {{ 'login.password_required' | translate }}
    </mat-error>
  </mat-form-field>

  <div class="d-flex align-items-center m-b-12">
    <mat-checkbox color="primary">{{ "login.remember_this_device"|translate }}</mat-checkbox>
  </div>
  <button mat-flat-button color="primary" class="w-100" [disabled]="!loginForm.valid">
    {{"login.log_in" | translate}}
  </button>
</form>
<span class="d-block f-w-500 d-block m-t-24">
  <a [routerLink]="['/recovery-password']" class="text-primary f-w-600 text-decoration-none m-l-auto f-s-14" >
      {{ "login.forgot_password"| translate }}
  </a>
</span>
